
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefanalysis",
      function () {
        return require("private-next-pages/debtreliefanalysis/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefanalysis"])
      });
    }
  